// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Fo-z","badgeLink":"Go-z","category":"Ho-z"};